import React from 'react';

import EpisodesListItem from './EpisodesListItem';

import { IPodcastEpisode } from '@wix/podcasts-common/dist/podcast';

import styles from './EpisodesList.scss';

interface IEpisodesListProps {
  episodes: IPodcastEpisode[];
  podcastImage: string;
  searchMode: boolean;
  focusIndex?: number;
  isLoading: boolean;
}

function EpisodesList({
  episodes,
  podcastImage,
  searchMode,
  focusIndex,
  isLoading,
}: IEpisodesListProps) {
  return (
    <ul className={styles.episodesList} role="region" aria-busy={isLoading}>
      {episodes.map((episode, index) => (
        <EpisodesListItem
          key={episode.id}
          podcastImage={podcastImage}
          episode={episode}
          isFirst={index === 0}
          isLatest={index === 0 && !searchMode}
          shouldFocus={focusIndex === index}
        />
      ))}
    </ul>
  );
}

export default EpisodesList;
